import React from "react";
import styles from "./index.module.scss";
import { useNavigate } from "react-router-dom";

interface DashboardCardProps {
  icon: React.ReactNode;
  title: string;
  value: string | number;
  isClickable?: boolean;
  route?: string;
}

const DashboardCard: React.FC<DashboardCardProps> = ({ icon, title, value, isClickable = false, route }) => {
  const navigate = useNavigate();

  const handleClick = () => {
    if (isClickable && route) {
      navigate(route);
    }
  };

  return (
    <div
      className={styles.card}
      style={{
        backgroundColor: (title === 'Total Products Added') ? '#3DCCC7' : "#ffffff",
        cursor: isClickable ? 'pointer' : 'default'
      }}
      onClick={handleClick}
    >
      <div className={styles.content}>
        <div
          className={styles.iconTitle}
          style={{ color: (title === 'Total Products Added') ? '#ffffff' : "#949494" }}>
          <div>{icon}</div>
          <div>{title}</div>
        </div>
        <div
          className={styles.value}
          style={{ color: (title === 'Total Products Added') ? '#ffffff' : '#3DCCC7' }}
        >{value}</div>
      </div>
    </div>
  );
};

export default DashboardCard;
